import HeadInfo from './HeadInfo';

export default HeadInfo;
